import type { CSSProperties } from '@compiled/react';
import { N50, N40, N20, N0, N40A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { BASE_HEADER_HEIGHT } from '../constants';

export const borderWidth = 1;
export const primaryBorder = `${borderWidth}px solid ${token('color.border', N50)}`;
export const secondaryBorderColor = token('color.border', N40);
export const secondaryBorder = `${borderWidth}px solid ${secondaryBorderColor}`;
export const itemTransition = 'background-color 100ms linear';

export const headerContainerBase: CSSProperties = {
	width: '100%',
	boxSizing: 'border-box',
	position: 'sticky',
	top: '0px',
	background: token('elevation.surface', N0),
};

export const headerShadow: CSSProperties = {
	boxShadow: `${token(
		'elevation.shadow.overflow',
		`0 ${token('space.050', '4px')} ${token('space.050', '4px')} -${token('space.025', '2px')} ${N40A}`,
	)}`,
};

export const headerBase: CSSProperties = {
	width: '100%',
	height: `${BASE_HEADER_HEIGHT}px`,
	boxSizing: 'border-box',
	borderBottom: secondaryBorder,
	backgroundColor: token('color.background.neutral', N20),
};
